import { Pipe, PipeTransform } from '@angular/core';
import { UtilService } from '../services/util.service';
import get_ from 'lodash-es/get';

@Pipe({
    name: 'sortData',
    standalone: false
})
export class SortDataPipe implements PipeTransform {
  constructor(public util: UtilService) {

  }

  transform(value: any, ...args: any[]): any {
    try {
      let field = args[0];
      if (value != undefined && Array.isArray(value) && value.length > 0 && !field['stopSorting']) {
        if (field["sortType"] != undefined && field["sortType"]) {
          return this.util.sort(value, field["sortType"],field.sortBy);
        } else {
          let key = field.sortBy != undefined && field.sortBy ? field.sortBy: field.getterValue;
         // return value.sort((firstElement, secondElement) => (firstElement[key].toLowerCase() > secondElement[key].toLowerCase()) ? 1 : ((secondElement[key].toLowerCase() > firstElement[key].toLowerCase()) ? -1 : 0))
         return value.sort(function (a, b) { 
          if(/^\d+$/.test(a[key]) && /^\d+$/.test(b[key])){
            return a[key] - b[key]
          }
          else{
            return (a[key].toLowerCase() > b[key].toLowerCase()) ? 1 : ((b[key].toLowerCase() > a[key].toLowerCase()) ? -1 : 0)
          }
        });
        }

      }
      else if (value != undefined && Array.isArray(value) && value.length > 0 && field['stopSorting'] != undefined && field['stopSorting']) {
        return value;
      }
    } catch (error) {
      if (value != undefined && Array.isArray(value) && value.length > 0) {
        return value;
      }
    }
  }

}